import { CreateAvatarCardLinkWidgetForm } from 'components/consumer-page-widgets/avatar-card-link-widget/CreateAvatarCardLinkWidgetForm';
import { CreateButtonArrayWidgetForm } from 'components/consumer-page-widgets/button-array-widget/CreateButtonArrayWidgetForm';
import { CreateCardLinkWidgetForm } from 'components/consumer-page-widgets/card-link-widget/CreateCardLinkWidgetForm';
import { CreateGridWidgetForm } from 'components/consumer-page-widgets/grid-widget/CreateGridWidgetForm';
import { CreateMetroAreaContainerForm } from 'components/consumer-page-widgets/metro-area-container-widget/CreateMetroAreaContainerWidgetForm';
import { CreateOfferingsPlatterWidgetForm } from 'components/consumer-page-widgets/offerings-platter-widget/CreateOfferingsPlatterWidgetForm';
import { CreateRowLayoutWidgetForm } from 'components/consumer-page-widgets/row-layout-widget/CreateRowLayoutWidgetForm';
import { CreateShopHeroWidgetForm } from 'components/consumer-page-widgets/shop-hero-widget/CreateShopHeroWidgetForm';
import {
  WidgetTypeCases,
  WidgetTypeSelect,
} from 'components/consumer-page-widgets/WidgetTypeSelect';
import { assertNever } from '@tock/shared/utils/typeUtils';
import { consumer } from '@tock/coretypes';
import { useHistory } from 'react-router';
import ClowncarBodyV2 from 'components/ClowncarBodyV2';
import ClowncarHeaderV2 from 'components/ClowncarHeaderV2';
import CreateMarketingFeatureWidgetForm from 'components/consumer-page-widgets/marketing-feature-widget/CreateMarketingFeatureWidgetForm';
import React, { FunctionComponent } from 'react';

const getWidgetFormForWidgetType = (
  type: WidgetTypeCases,
  onComplete: () => void,
  marketingWidgets?: consumer.NamedConfiguration[]
) => {
  switch (type) {
    case 'cardLinkWidgetConfig':
      return <CreateCardLinkWidgetForm onCompleteOrCancel={onComplete} />;
    case 'rowLayoutWidgetConfig':
      return <CreateRowLayoutWidgetForm onCompleteOrCancel={onComplete} />;
    case 'avatarCardLinkWidgetConfig':
      return <CreateAvatarCardLinkWidgetForm onCompleteOrCancel={onComplete} />;
    case 'shopHeroWidgetConfig':
      return <CreateShopHeroWidgetForm onCompleteOrCancel={onComplete} />;
    case 'buttonArrayWidgetConfig':
      return <CreateButtonArrayWidgetForm onCompleteOrCancel={onComplete} />;
    case 'gridWidgetConfig':
      return <CreateGridWidgetForm onCompleteOrCancel={onComplete} displayMode={'GRID'} />;
    case 'carouselWidgetConfig':
      return <CreateGridWidgetForm onCompleteOrCancel={onComplete} displayMode={'CAROUSEL'} />;
    case 'marketingFeaturesWidgetConfig':
      return <CreateMarketingFeatureWidgetForm onCompleteOrCancel={onComplete} />;
    case 'metroAreaWidgetConfig':
      return <CreateMetroAreaContainerForm onCompleteOrCancel={onComplete} />;
    case 'offeringsPlatterWidgetConfig':
      return <CreateOfferingsPlatterWidgetForm onCompleteOrCancel={onComplete} />;
    default:
      assertNever(type);
  }
};

export const CreateConsumerPageWidgetRoute: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const [selectedWidgetType, setSelectedWidgetType] =
    React.useState<WidgetTypeCases>('cardLinkWidgetConfig');

  const history = useHistory();

  const onCreate = () => history.goBack();

  const form = getWidgetFormForWidgetType(selectedWidgetType, onCreate);

  return (
    <div className="Content">
      <ClowncarHeaderV2 heading="Create new widget" />
      <div className="Main">
        <ClowncarBodyV2>
          <WidgetTypeSelect
            selectedWidgetType={selectedWidgetType}
            onChangeType={setSelectedWidgetType}
          />
          {form}
        </ClowncarBodyV2>
      </div>
    </div>
  );
};
